import React from 'react';
import Label from '../Label';
import ABSInput from '../../ABSInput';
import './index.less';

export interface ISampleInputProps {
  onPressEnter?: () => void;
  
  title: string;
  onTextChange?: (value: string) => void;
  inputValue?: string;
  placeholder: string;

}

export interface ISampleInputState {
  keyword?: string;
}

class SampleInput extends React.Component<ISampleInputProps, ISampleInputState> {
  constructor(props: any) {
    super(props);
    const { inputValue } = this.props;
    this.state = {
      keyword: inputValue || '',
    };
  }

  onTextChange = (keyword) => {
    this.setState({ keyword: keyword });
    const { onTextChange } = this.props;
    if (onTextChange) { onTextChange(keyword); }
  }

  onPressEnter = (keyword) => {
    const { onPressEnter } = this.props;
    if (onPressEnter) {
      onPressEnter();
    }
  }

  extraValue() {
    const { keyword } = this.state;
    return {
      keyword: keyword,
    };
  }

  initDefaultValue() {
    this.setState({ keyword: '' });
  }

  render() {
    const { keyword } = this.state;
    const { title, placeholder } = this.props;
    return (
      <div className="abs-single-input">
        <Label title={title} className="abs-single-input-title" />
        <ABSInput
          placeholder={placeholder}
          onChange={this.onTextChange}
          onPressEnter={this.onPressEnter}
          value={keyword}
        />
      </div>
    );
  }
}

export default SampleInput;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSFilterPanel/SampleInput/index.tsx